import { Modal } from 'tea-component';
import RepeatSetting from '../RepeatSetting';
import SummaryDetail from '../SummaryDetail';
import React, { useMemo, useRef, useState } from 'react';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import RegularListeningSetting from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/component/Filter/KeywordUrlFilter/components/RegularListeningSetting';

export default function SummaryModal(props: any) {
  const {
    visible,
    modalType,
    toggleVisible,
    formatMessage,
    gameInfo,
    records,
    request,
    wholeGameInfo,
    category
  } = props;

  const getCaptions = useMemo(() => {
    if (modalType === 'detail') return formatMessage({ id: 'Summary Detail' });
    if (modalType === 'edit') {
      return formatMessage({ id: 'Edit Repeat Settings' });
    }

    return null;
  }, [formatMessage, modalType]);

  const modalBody = useMemo(() => {
    if (modalType === 'detail') {
      return (
        <SummaryDetail
          details={records}
          formatMessage={formatMessage}
          gameInfo={gameInfo}
          wholeGameInfo={wholeGameInfo}
        />
      );
    }
    if (modalType === 'edit') {
      return (
        <RepeatSetting
          gameInfo={gameInfo}
          filter={records}
          toggleVisible={toggleVisible}
          isEdit
          request={request}
        />
      );
    }

    return null;
  }, [formatMessage, gameInfo, modalType, records]);

  if (category !== 'repeat_summary_task' && modalType !== 'detail') {
    return (
      <RegularListeningSetting
        visible={visible}
        onClose={() => toggleVisible(false)}
        onConfirm={(data) => {
          buriedBtnPoint('ConfirmRegularListening', data);
          toggleVisible(false);
        }}
        currentFilter={records}
        gameInfo={gameInfo}
        isEdit
        request={request}
      />
    );
  }

  return (
    <Modal
      visible={visible}
      caption={getCaptions}
      onClose={toggleVisible}
      size={800}
      destroyOnClose
      className={'dbo-ai-summary-setting-modal'}
    >
      <Modal.Body>{modalBody}</Modal.Body>
    </Modal>
  );
}

export function useModalData() {
  const [modalProps, setModalProps] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const requestSummary = useRef<any>(null);
  const [category, setCategory] = useState('');


  const toggleModal = (type: string, props: any = {}, tab: string = '') => {
    buriedBtnPoint(
      type === 'edit' ? 'EditRepeatSettings' : 'RepeatDetailSetting',
    );

    setModalType(type);
    setModalVisible(!modalVisible);
    setModalProps(props);
    setCategory(tab);
  };

  return {
    modalProps,
    modalVisible,
    modalType,
    toggleModal,
    requestSummary,
    category
  };
}
